import { render, staticRenderFns } from "./CreateDataSystemForSchool.vue?vue&type=template&id=68c7d570&scoped=true"
import script from "./CreateDataSystemForSchool.vue?vue&type=script&lang=js"
export * from "./CreateDataSystemForSchool.vue?vue&type=script&lang=js"
import style0 from "./CreateDataSystemForSchool.vue?vue&type=style&index=0&id=68c7d570&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c7d570",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68c7d570')) {
      api.createRecord('68c7d570', component.options)
    } else {
      api.reload('68c7d570', component.options)
    }
    module.hot.accept("./CreateDataSystemForSchool.vue?vue&type=template&id=68c7d570&scoped=true", function () {
      api.rerender('68c7d570', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/CreateDataSystemForSchool.vue"
export default component.exports